import { extendTheme } from "@chakra-ui/react";
import colors from "./colors";

import { alertAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(alertAnatomy.keys);

const PRIMARY = "#7A1F35";
const PRIMARY_HOVER = "#5C1628";

const solid = definePartsStyle((props) => {
    const bg =
        props.status === "error"   ? "#E53E3E" :
        props.status === "warning" ? "#DD6B20" :
        props.status === "info"    ? "#3182CE" : "#7A1F35"; // success + domyślnie zielony
    return {
        container: {
            bg,
            color: "white",
            borderRadius: "lg",
            boxShadow: "xl",
        },
        icon: { color: "white" },
        title: { fontWeight: 700 },
        description: { opacity: 0.95 },
    };
});

const Alert = defineMultiStyleConfig({
    variants: { solid },
});

const theme = extendTheme({
    colors,
    fonts: {
        heading: "'Bricolage Grotesque', 'DM Sans', system-ui, sans-serif",
        body: "'DM Sans', system-ui, sans-serif",
    },
    styles: {
        global: {
            body: {
                bg: "surface.page",
                color: "ink.900",
            },
        },
    },
    radii: {
        card: "20px",
        control: "12px",
    },
    shadows: {
        card: "0 1px 2px rgba(14,26,23,0.04), 0 10px 28px rgba(14,26,23,0.06)",
        raised: "0 1px 2px rgba(14,26,23,0.04), 0 16px 40px rgba(14,26,23,0.07)",
    },
    components: {
        Alert,
        Heading: {
            baseStyle: {
                fontFamily: "heading",
                letterSpacing: "-0.02em",
                color: "ink.900",
            },
        },
        Button: {
            baseStyle: {
                borderRadius: "control",
                fontWeight: 600,
                transition: "background-color .15s ease, color .15s ease, transform .15s ease",
                _disabled: {
                _hover: { bg: undefined, color: undefined }
                }
            },

            variants: {
                solid: {
                bg: PRIMARY,
                color: "white",
                _hover: {
                bg: PRIMARY_HOVER,
                boxShadow: "md",
                },
                _active: { bg: PRIMARY_HOVER, color: "white" }
                },

                arrow: {
                color: "ink.900",
                bg: "transparent",
                _hover: { color: "brand.500" }
                },

                cta: {
                bg: "white",
                color: PRIMARY,
                borderRadius: "full",
                px: 8,
                py: 6,
                w: "fit-content",
                fontFamily: "body",
                fontSize: "18px",
                _hover: {
                    bg: "whiteAlpha.900",
                    color: PRIMARY
                }
                }
            },

            defaultProps: {
                variant: "solid"
            }
            },

        Input: {
            baseStyle: {
                field: {
                    _focus: {
                        border: "2px solid #7A1F35 !important",
                        boxShadow: "none !important",
                    },
                    border: "1px solid #DED3D4 !important",
                    borderRadius: "control",
                },
            },
        },
        Textarea: {
            baseStyle: {
                _focus: {
                    border: "2px solid #7A1F35 !important",
                    boxShadow: "none !important",
                },
                border: "1px solid #DED3D4 !important",
                borderRadius: "control",
            },
        },
        FormLabel: {
            baseStyle: {
                fontFamily: "body",
                fontWeight: 400,
                fontStyle: "normal",
                fontSize: "16px",
                lineHeight: "100%",
                letterSpacing: "0"
            }
        },
        IconButton: {
            variants: {
            arrow: {
            color: "ink.900",
            bg: "transparent",
            _hover: {
                color: "brand.500",
            }
        }
    },
    defaultProps: {
        variant: "arrow"
    }
}

    }
});

export default theme;



